/* eslint-disable import/prefer-default-export */
/* eslint-disable multiline-ternary */
import styled, { css } from 'styled-components';
import { Col } from '../../../base/Grid';

export const PhotoCol = styled(Col)`
${({ theme }) => {
    const mobile = theme.useMediaQuery(theme.breakpoints.down('medium'));
    return css`
      margin-bottom: ${mobile ? '1.5rem' : 0};
    `;
  }}
`;
